import {useContext} from "react";

import {SiteConfigContext} from "./SiteConfigContext";
import {SiteConfigContextInterface} from "./interfaces";

export default function useSitesConfig(): SiteConfigContextInterface {
  return useContext(SiteConfigContext);
}
